import React, { useState, useEffect, useRef } from 'react'

import { usePageTitle, useQuery } from '../../../utils/util'
import SingleAnalyticsHeader from '../student/SingleAnalyticsHeader'
import ClassCardWidget from './ClassCardWidget'
import ClassAnalyticsWidgets, { daysFilterList } from './ClassAnalyticsWidgets'
import { useTranslation } from 'react-i18next'
import DayFilteringWidget from '../student/DayFilteringWidget'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { calculateDateRange } from '../../../utils/dateUtils'

function ClassAnalyticsHome() {
    const location = useLocation()
    const history = useHistory()
    const { t } = useTranslation()
    const query = useQuery()
    const classId = query.get('id')
    const [selectedClass, setSelectedClass] = useState({})
    const [daysFilter, setDaysFilter] = useState(() => {
        const params = new URLSearchParams(location.search)

        const code = params.get('days')

        const match = daysFilterList.find((item) => item.code === code)
        const selectedFilter = match || daysFilterList[0]

        const { startDate, endDate } = calculateDateRange(selectedFilter)

        return { ...selectedFilter, startDate, endDate }
    })
    const [showFilter, setShowFilter] = useState(false)
    const widgetsRef = useRef(null)

    useEffect(() => {
        const params = new URLSearchParams(location.search)

        if (daysFilter?.code) params.set('days', daysFilter.code)

        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        })
    }, [daysFilter])

    usePageTitle(`Upstrive Education - Class ${selectedClass?.name ?? ''} Analytics`)

    useEffect(() => {
        const el = widgetsRef.current
        if (!el) return

        const handleScroll = () => {
            setShowFilter(el.scrollTop > 100)
        }

        el.addEventListener('scroll', handleScroll)
        handleScroll()

        return () => el.removeEventListener('scroll', handleScroll)
    }, [location])

    return (
        <div
            id="studentAnalyticsId"
            className="page-shell flex flex-col flex-1 min-h-0 bg-lightBG overflow-y-auto"
            key={classId}
        >
            <div className="max-w-[1360px] mx-[auto] w-full ">
                <SingleAnalyticsHeader />
                <div className="mt-[10px] flex flex-row items-center justify-between">
                    <p className="page-title text-darkenPurple font-semibold">{t('Classroom analytics')}</p>
                    <div
                        className="transition-all duration-300 ease-in-out"
                        style={{
                            opacity: showFilter ? 1 : 0,
                            visibility: showFilter ? 'visible' : 'hidden',
                            transform: showFilter ? 'translateY(0)' : 'translateY(-10px)',
                            zIndex: 4,
                        }}
                    >
                        <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
                    </div>
                </div>
                <div className="w-full border-b border-b-white mt-5"></div>
                <div className="flex flex-row transition-all xl:gap-6 min-h-[685px] " style={{ height: 'max(685px, calc(100vh - 160px))' }}>
                    <div className="pt-[20px]" data-tour="class-card">
                        <ClassCardWidget selectedClass={selectedClass} setSelectedClass={setSelectedClass} />
                    </div>
                    <div className="flex flex-1" style={{ minHeight: 'max(685px, 100%)' }} data-tour="analytics-widgets" id="analytics-widgets">
                        <ClassAnalyticsWidgets ref={widgetsRef} selectedClass={selectedClass} subjectId={classId} daysFilter={daysFilter} setDaysFilter={setDaysFilter} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClassAnalyticsHome
